import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import api from '../services/api'

import './styles/Login.css';
import icon from '../imgs/logo4.png';
import { isMobile } from 'react-device-detect';

const swal = withReactContent(Swal)

function Login() {
    const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));

    useEffect(() => {
        if (isMobile) window.location.href = '/sistema/vendaexterna'
        if (auth.authenticated) window.location.href = '/sistema/home'
    }, [auth])

    function login(e) {
        e.preventDefault();
        //Pega valores do form
        const form = document.getElementById('loginForm');
        const data = new FormData(form);

        if (data.get('login') === '') {
            swal.fire('Usuário não informado!', 'Informe o usuário.', 'warning')
            return
        }

        if (data.get('senha') === '') {
            swal.fire('Senha não informada!', 'Informe a senha.', 'warning')
            return
        }
        //Converte FormData em JSON
        var object = {};

        data.forEach(function (value, key) {
            object[key] = value;
        });
        // if ((data.get('login') !== 'admin') || (data.get('senha') !== '555'))
        //     { swal.fire('Login inválido!', 'Verifique o Usuário e a Senha.', 'warning') }
        // else { localStorage['authsistema'] =  JSON.stringify({ authenticated: true, user: 1, name: 'Admin', last_activity: new Date() }) }

        api.post('usuario_externo/login', object)
            .then(function (response) {
                console.log(response.data[0])
                let { PK_UEX, NOME, ULTIMO_LOGIN, TIPO_GRUPO, ATIVO, LIBERA_IDADE } = response.data[0];
                if (PK_UEX > 0 && ATIVO == 'S') {
                    api.defaults.headers.common['token'] = response.data.token;
                    localStorage['authKSA'] = JSON.stringify({ authenticated: true, user: PK_UEX, name: NOME, ULTIMO_LOGIN, last_activity: new Date(), tipo_grupo: TIPO_GRUPO, libera_idade:LIBERA_IDADE, access_token: response.data.token })
                    window.location.href = '/sistema/home'
                } else {
                    swal.fire('Login inválido!', 'Verifique o Usuário e a Senha.', 'warning')
                }
            })
            .catch(function (error) {
                swal.fire('Login inválido!', 'Verifique o Usuário e a Senha.', 'warning')
            });
    }

    return (
        <div className="Login">
            <div className="form">
                <img alt="fr_logo" src={icon} title="KSA Clube" className="logo" />
                {/* <p>sistema Interno</p> */}
                <form className="form-signin" id="loginForm" onSubmit={login}>
                    <div className="form-label-group">
                        <input type="text" id="login" name="login" className="loginInput" placeholder="Usuário" />
                        <label htmlFor="login">Usuário</label>
                    </div>
                    <div className="form-label-group">
                        <input type="password" id="senha" name="senha" className="loginInput" placeholder="Senha" />
                        <label htmlFor="senha">Senha</label>
                    </div>
                    <button className="loginButton" type="submit" rel="nofollow">
                        <span><p className='loginButtonText'>Entrar</p></span>
                    </button>
                    <div >
                        <a href='/sistema/forgotPw' style={{ color: '#F1873B' }}>Esqueci minha senha</a>
                    </div>
                    <div >
                        <a href='/sistema/cadastre_se' style={{ color: '#F1873B' }}>Associado - Cadastre-se</a>
                    </div>

                </form>
            </div>
        </div>
    );
}

export default Login;
